'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const i18n = require('i18next');
const RelatedKeys = require('common/domain/value/related-keys');
const AuthService = require('system/domain/service/auth');
const NavView = require('balus/ui/view/body/diagram/nav/index');
const ToolbarView = require('balus/ui/view/body/diagram/toolbar/index');
const DiagramView = require('balus/ui/view/body/diagram/content/diagram');
const DetailView = require('balus/ui/view/body/diagram/content/detail');
const TagAction = require('system/domain/action/tag');
const DiffModeIndicatorView = require('system/ui/view/mode-indicator/diff');
const SidebarView = require('common/ui/view/sidebar/index');
const SidebarCollection = require('common/ui/view/sidebar/collection');
const CommentCollectionRepository = require('communication/domain/repository/comment-collection');
const TaskCollectionRepository = require('communication/domain/repository/task-collection');
const TaskRelatedListView = require('communication/ui/view/task/related-list');
const ElementAction = require('system/domain/action/element');
const DiagramAction = require('system/domain/action/diagram');
const ElementRepository = require('system/domain/repository/element');
const DiagramRepository = require('system/domain/repository/diagram');
const TagListView = require('system/ui/view/tag/list');
const OwnerListView = require('system/ui/view/owner/list');
const CoverView = require('balus/ui/view/body/diagram/cover');
const DescriptionView = require('balus/ui/view/body/diagram/sidebar/description');
const TimelineView = require('balus/ui/view/timeline/index');
const AdditionalView = require('balus/ui/view/additional/index');
const ContentTemplate = require('balus/ui/template/body/diagram-diff/index.hbs');

module.exports = Mn.View.extend({
    className: 'row',
    template: ContentTemplate,
    regions: {
        nav: '#nav',
        cover: '#cover',
        toolbar: '#toolbar',
        fromDetail: '#from #detail',
        fromDiagram: '#from .diagram',
        toDetail: '#to #detail',
        toDiagram: '#to .diagram',
        sidebar: '#sidebar',
        modeIndicator: '#mode-indicator',
        diffList: '#diff-list-wrapper'
    },

    onRender: function() {
        const context = this.getOption('context');
        const appInfo = context.getAppInfo();
        const user = context.getUser();
        const group = context.getGroup();
        const project = context.getProject();
        const channel = this.getOption('channel');
        const urlParams = new URLSearchParams(location.search);
        const toDt = urlParams.get('to');
        const fromDt = urlParams.get('from');
        const projectID = this.model.getProjectId();
        const diagramID = this.model.id;
        const oldContext = {
            projectId: projectID,
            diagramId: diagramID,
            dt: null
        };
        const toContext = {
            projectId: projectID,
            diagramId: diagramID,
            dt: toDt
        };
        const fromContext = {
            projectId: projectID,
            diagramId: diagramID,
            dt: fromDt
        };

        let mode = 'snapshot';
        const auth = new AuthService({
            mode: mode,
            isMember: group.isMember(user ? user.id : null),
            isAdmin: group.isAdmin(user ? user.id : null)
        });

        this.showChildView('modeIndicator', new DiffModeIndicatorView({
            fromDt: fromDt,
            toDt: toDt,
        }));

        this.showChildView('cover', new CoverView({
            model: this.model,
            project: project
        }));

        Promise.all(
           [
               DiagramAction.fetchDiagramOnce(projectID, diagramID, fromDt),
               DiagramAction.fetchDiagramOnce(projectID, diagramID, toDt),
               ElementAction.fetchElementsOnce({
                   context: toContext
               }),
               ElementAction.fetchElementsOnce({
                   context: fromContext
               }),
               TagAction.fetchTagsOnce(this.model.getProjectId())
           ]
        )
            .then(() => {
                const pattern = new RegExp('#/elements/([0-9a-f]+)');
                const id = location.hash && location.hash.match(pattern) &&
                    location.hash.match(pattern)[1];
                let models = [];
                const nodes = ElementRepository.getNodes({
                    context: oldContext
                });

                const fromDiagram = DiagramRepository.getDiagrams({
                    context: fromContext
                }).get(diagramID);
                const toDiagram = DiagramRepository.getDiagrams({
                    context: toContext
                }).get(diagramID);

                this.showChildView('fromDiagram', new DiagramView({
                    model: fromDiagram,
                    context: context,
                    oldContext: fromContext,
                    channel: channel,
                    auth: auth,
                    user: user,
                    group: group,
                    project: project,
                    appInfo: appInfo,
                    widthFactor: 0.5
                }));
                this.showChildView('toDiagram', new DiagramView({
                    model: toDiagram,
                    context: context,
                    oldContext: toContext,
                    channel: channel,
                    auth: auth,
                    user: user,
                    group: group,
                    project: project,
                    appInfo: appInfo,
                    widthFactor: 0.5
                }));
                this.showChildView('fromDetail', new DetailView({
                    model: fromDiagram,
                    context: context,
                    oldContext: fromContext,
                    channel: channel,
                    auth: auth,
                    user: user,
                    group: group,
                    project: project,
                    appInfo: appInfo
                }));
                this.showChildView('toDetail', new DetailView({
                    model: toDiagram,
                    context: context,
                    oldContext: toContext,
                    channel: channel,
                    auth: auth,
                    user: user,
                    group: group,
                    project: project,
                    appInfo: appInfo
                }));

                let sync = false;
                this.getChildView('fromDiagram').frame.on('zoom', (pos, scale) => {
                    if(sync) {
                        return;
                    }

                    sync = true;
                    this.getChildView('toDiagram').frame.transform({
                        x: pos.x,
                        y: pos.y,
                        scale: scale
                    });
                    sync = false;
                });
                this.getChildView('toDiagram').frame.on('zoom', (pos, scale) => {
                    if(sync) {
                        return;
                    }

                    sync = true;
                    this.getChildView('fromDiagram').frame.transform({
                        x: pos.x,
                        y: pos.y,
                        scale: scale
                    });
                    sync = false;
                });

                const fromNodes = ElementRepository.getNodes({context: fromContext});
                const fromLinks = ElementRepository.getLinks({context: fromContext});
                const toNodes = ElementRepository.getNodes({context: toContext});
                const toLinks = ElementRepository.getLinks({context: toContext});

                this.listenTo(fromNodes, 'select', model => {
                    const m = toNodes.get(model.id);
                    if(m) {
                        m.select();
                    }
                });
                this.listenTo(fromLinks, 'select',  model => {
                    const m = toLinks.get(model.id);
                    if(m) {
                        m.select();
                    }
                });
                this.listenTo(toNodes, 'select', model => {
                    const m = fromNodes.get(model.id);
                    if(m) {
                        m.select();
                    }
                });
                this.listenTo(toLinks, 'select',  model => {
                    const m = fromLinks.get(model.id);
                    if(m) {
                        m.select();
                    }
                });

                if(id) {
                    models = channel.request('find:elements:idStartsWith', id);
                }

                if(models.length == 1) {
                    models[0].select();
                    channel.request('canvas:zoomTo', models[0], 0);
                } else if (nodes.length > 0) {
                    channel.request('canvas:showFull', 0);
                }

            });

        this.showChildView('nav', new NavView({
            model: project,
            context: this.getOption('context').getParent(),
        }));

        this.showChildView('toolbar', new ToolbarView({
            model: this.model,
            context: context,
            oldContext: oldContext,
            channel: channel,
            messengerChannel: this.getOption('messengerChannel'),
            auth: auth,
            user: user,
            group: group,
            project: project
        }));

        Promise.all([
            CommentCollectionRepository.find(project).byKey(this.model.key).fetchFirstPage(),
            TaskCollectionRepository.find(project).byKey(this.model.key).fetchFirstPage()
        ])
            .then(values => {
                const comments = values[0];
                const tasks = values[1];
                const relatedKeys = new RelatedKeys([this.model.key]);

                const navs = new SidebarCollection(
                    [
                        {
                            name: 'description',
                            icon: 'fa fa-info-circle',
                            label: 'module/word:description',
                            view: new DescriptionView({
                                model: this.model
                            })
                        },
                        {
                            name: 'timeline',
                            icon: 'fa fa-comments-o',
                            label: 'module/word:timeline',
                            header: i18n.t('balus_template_body_diagram:sidebar.timeline-title', {name: this.model.get('name'), interpolation: { escapeValue: false }}),
                            view: new TimelineView({
                                model: this.model,
                                collection: comments,
                                context: context
                            }),
                            badge: {
                                content: function(){
                                    return comments.getTotalCount();
                                },
                                listen: function(onChange){
                                    comments.on('change:totalCount', onChange);
                                }
                            }
                        },
                        {
                            name: 'task',
                            icon: 'fa fa-check-square',
                            label: 'module/word:task',
                            header: i18n.t('balus_template_body_diagram:sidebar.timeline-title', {name: this.model.get('name'), interpolation: { escapeValue: false }}),
                            view: new TaskRelatedListView({
                                collection: tasks,
                                context: context,
                                AdditionalView: AdditionalView,
                                relatedKeys: relatedKeys
                            }),
                            badge: {
                                content: function(){
                                    return tasks.getTotalCount();
                                },
                                listen: function(onChange){
                                    tasks.on('change:totalCount', onChange);
                                }
                            }
                        },
                        {
                            name: 'members',
                            icon: 'fa fa-user',
                            label: 'module/word:member',
                            view: new OwnerListView({
                                collection: group.getMembers({withSuspended: true}),
                                context: oldContext,
                                channel: channel,
                                diagramContext: oldContext
                            })
                        },
                        {
                            name: 'tags',
                            icon: 'fa fa-tags',
                            label: 'module/word:tag',
                            view: new TagListView({
                                editable: auth.isEditable(),
                                context: oldContext,
                                channel: channel,
                                diagramContext: oldContext
                            })
                        }
                    ]
                );

                this.showChildView('sidebar', new SidebarView({
                    model: this.model,
                    navs: navs,
                    horizontalNav: true
                }));
                this.getChildView('toolbar').renderNav(navs);

                const sidebarView = this.getChildView('sidebar');
                channel.reply('cmd:sidebar:comment:activate', function(){
                    sidebarView.activate('timeline');
                });
                const timelineView = navs.getByName('timeline').getView();

                channel.on('append:comment:records', function(records){
                    sidebarView.activate('timeline');
                    _.each(records, record => {
                        timelineView.addRecord(record);
                    });
                    timelineView.openComment();
                });

                channel.on('append:comment:record', function(record){
                    sidebarView.activate('timeline');
                    timelineView.addRecord(record);
                    timelineView.openComment();
                });

                channel.on('append:comment:relations', function(relation){
                    sidebarView.activate('timeline');
                    timelineView.addRelation(relation);
                    timelineView.openComment();
                });

                const activateComment = function() {
                    const pattern = new RegExp('#/comments/([0-9a-f]+)');
                    const commentID = location.hash && location.hash.match(pattern) && location.hash.match(pattern)[1];
                    if(commentID) {
                        const comment = comments.getCommentByID(commentID);
                        if(comment) {
                            channel.request('cmd:sidebar:comment:activate');
                            comment.activate();
                        }
                    }
                };

                activateComment();
                window.addEventListener('hashchange', activateComment, false);
            });

        // id が str から始まる element のリストを返す
        const getElementsOfIdStartsWith = function(str) {
            if (str[0] == '#') {
                str = str.slice(1);
            }
            const idStartsWith = function(model) {
                return model.id.indexOf(str) == 0;
            };
            const nodes = ElementRepository.getNodes({
                context: oldContext
            }).filter(idStartsWith);
            const links = ElementRepository.getLinks({
                context: oldContext
            }).filter(idStartsWith);

            return _.flatten([nodes, links]);
        };
        channel.reply('find:elements:idStartsWith', getElementsOfIdStartsWith);
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/diagram-diff/index.js